<template>
    <fieldset :class="fieldsetClasse">
        <button :id="id" class="button btn rounded-0" :class="classe" :type="tipo" :style="css" @click='clickable'>
            <i v-if="ico && icoPosition == 'left'" :class="ico + (label == '' ? ' pr-0' : '')"></i>
            {{ label }}
            <i v-if="ico && icoPosition == 'right'" :class="ico + (label == '' ? ' pr-0' : '')"></i>
        </button>
    </fieldset>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'Realizar Ação',
            },
            tipo: {
                type: String,
                default: 'button',
            },
            ico: {
                type: String,
                default: null,
            },
            icoPosition: {
                type: String,
                default: 'right',
            },
            css: {
                type: String,
                default: '',
            },
            classe: {
                type: String,
                default: 'button-dark btn-dark',
            },
            fieldsetClasse: {
                type: String,
                default: 'col',
            },
            id: {
                type: String,
                default: () => {
                    return 'button_' + _.toString(Math.floor((Math.random() * 10000) + 1))
                },
            },
            click: {
                type: Function,
                default: () => {
                    return false
                }
            },
        },
        methods: {
          clickable(){
            if(_.isFunction(this.click)){
              this.click()
            }
            this.$emit('click')
          }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/form/button.vue